function DerivedDataDeriver()
{
    // //////// private members
    var average = require('./derived-datasets/average.js');
    var zero = require('./derived-datasets/zero.js');

    // //////// public members
    this.derive = function(inputData, derivativeParameters, derivedDataDatasetId){
        var derivedData;
        switch(derivativeParameters.type){
            case "average":
                derivedData = average.derive(inputData, derivativeParameters.data, derivedDataDatasetId);
                break;
            case "zero":
                derivedData = zero.derive(inputData, derivativeParameters.data, derivedDataDatasetId);
                break;
        }

        return derivedData;
    }
}

module.exports = new DerivedDataDeriver();



// WEBPACK FOOTER //
// ./src/core/services/data-service/derived-data-deriver.js